const CheckStatus = {
    OPEN: 'open',
    PENDING: 'pending',
    WAITING_REVIEW: 'waiting-review',
    DONE: 'done',
    INVOICED: 'invoiced',
    UNDEFINED: 'undefined'
};

module.exports = CheckStatus;